import { useEffect } from 'react';

type Options = {
  skip?: boolean;
};

export const useUpdateStartingBid = (
  reservePrice: number,
  updateCb: (startingBid: number) => void,
  { skip = false }: Options
) => {
  useEffect(() => {
    if (skip) return;
    const updateStartingBid = () => {
      if (!reservePrice) return;
      const newStartingBid = Math.ceil((reservePrice * 0.8) / 100) * 100;
      updateCb(newStartingBid);
      // dispatch(change('manualUploadForm', 'starting_bid', newStartingBid));
    };

    const debouncedUpdate = setTimeout(() => {
      updateStartingBid();
    }, 500);

    return () => clearTimeout(debouncedUpdate);
  }, [reservePrice, skip, updateCb]);
};
